"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadsApi = exports.UploadsApiFactory = exports.UploadsApiFp = exports.UploadsApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * UploadsApi - axios parameter creator
 * @export
 */
var UploadsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Complete S3 multipart upload for submission media
         * @param {CompleteSubmissionMultipartUploadDto} completeSubmissionMultipartUploadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerCompleteSubmissionMultipartUploadV1: function (completeSubmissionMultipartUploadDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([completeSubmissionMultipartUploadDto_1], args_1, true), void 0, function (completeSubmissionMultipartUploadDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'completeSubmissionMultipartUploadDto' is not null or undefined
                            (0, common_1.assertParamExists)('uploadsControllerCompleteSubmissionMultipartUploadV1', 'completeSubmissionMultipartUploadDto', completeSubmissionMultipartUploadDto);
                            localVarPath = "/v1/uploads/multipart/complete";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(completeSubmissionMultipartUploadDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Initiate S3 multipart upload for submission media
         * @param {InitiateSubmissionMultipartUploadDto} initiateSubmissionMultipartUploadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerInitiateSubmissionMultipartUploadV1: function (initiateSubmissionMultipartUploadDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([initiateSubmissionMultipartUploadDto_1], args_1, true), void 0, function (initiateSubmissionMultipartUploadDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'initiateSubmissionMultipartUploadDto' is not null or undefined
                            (0, common_1.assertParamExists)('uploadsControllerInitiateSubmissionMultipartUploadV1', 'initiateSubmissionMultipartUploadDto', initiateSubmissionMultipartUploadDto);
                            localVarPath = "/v1/uploads/multipart/initiate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(initiateSubmissionMultipartUploadDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get S3 presigned URLs for multipart submission upload parts
         * @param {PresignSubmissionPartsDto} presignSubmissionPartsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerPresignSubmissionMultipartPartsV1: function (presignSubmissionPartsDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([presignSubmissionPartsDto_1], args_1, true), void 0, function (presignSubmissionPartsDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'presignSubmissionPartsDto' is not null or undefined
                            (0, common_1.assertParamExists)('uploadsControllerPresignSubmissionMultipartPartsV1', 'presignSubmissionPartsDto', presignSubmissionPartsDto);
                            localVarPath = "/v1/uploads/multipart/presign-parts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(presignSubmissionPartsDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get S3 presigned URL for client-side upload
         * @param {PresignRequestDto} presignRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerPresignV1: function (presignRequestDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([presignRequestDto_1], args_1, true), void 0, function (presignRequestDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'presignRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('uploadsControllerPresignV1', 'presignRequestDto', presignRequestDto);
                            localVarPath = "/v1/uploads/presign";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(presignRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UploadsApiAxiosParamCreator = UploadsApiAxiosParamCreator;
/**
 * UploadsApi - functional programming interface
 * @export
 */
var UploadsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UploadsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Complete S3 multipart upload for submission media
         * @param {CompleteSubmissionMultipartUploadDto} completeSubmissionMultipartUploadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerCompleteSubmissionMultipartUploadV1: function (completeSubmissionMultipartUploadDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadsControllerCompleteSubmissionMultipartUploadV1(completeSubmissionMultipartUploadDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UploadsApi.uploadsControllerCompleteSubmissionMultipartUploadV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Initiate S3 multipart upload for submission media
         * @param {InitiateSubmissionMultipartUploadDto} initiateSubmissionMultipartUploadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerInitiateSubmissionMultipartUploadV1: function (initiateSubmissionMultipartUploadDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadsControllerInitiateSubmissionMultipartUploadV1(initiateSubmissionMultipartUploadDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UploadsApi.uploadsControllerInitiateSubmissionMultipartUploadV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get S3 presigned URLs for multipart submission upload parts
         * @param {PresignSubmissionPartsDto} presignSubmissionPartsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerPresignSubmissionMultipartPartsV1: function (presignSubmissionPartsDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadsControllerPresignSubmissionMultipartPartsV1(presignSubmissionPartsDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UploadsApi.uploadsControllerPresignSubmissionMultipartPartsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get S3 presigned URL for client-side upload
         * @param {PresignRequestDto} presignRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerPresignV1: function (presignRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadsControllerPresignV1(presignRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UploadsApi.uploadsControllerPresignV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.UploadsApiFp = UploadsApiFp;
/**
 * UploadsApi - factory interface
 * @export
 */
var UploadsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UploadsApiFp)(configuration);
    return {
        /**
         *
         * @summary Complete S3 multipart upload for submission media
         * @param {CompleteSubmissionMultipartUploadDto} completeSubmissionMultipartUploadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerCompleteSubmissionMultipartUploadV1: function (completeSubmissionMultipartUploadDto, options) {
            return localVarFp.uploadsControllerCompleteSubmissionMultipartUploadV1(completeSubmissionMultipartUploadDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Initiate S3 multipart upload for submission media
         * @param {InitiateSubmissionMultipartUploadDto} initiateSubmissionMultipartUploadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerInitiateSubmissionMultipartUploadV1: function (initiateSubmissionMultipartUploadDto, options) {
            return localVarFp.uploadsControllerInitiateSubmissionMultipartUploadV1(initiateSubmissionMultipartUploadDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get S3 presigned URLs for multipart submission upload parts
         * @param {PresignSubmissionPartsDto} presignSubmissionPartsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerPresignSubmissionMultipartPartsV1: function (presignSubmissionPartsDto, options) {
            return localVarFp.uploadsControllerPresignSubmissionMultipartPartsV1(presignSubmissionPartsDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get S3 presigned URL for client-side upload
         * @param {PresignRequestDto} presignRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerPresignV1: function (presignRequestDto, options) {
            return localVarFp.uploadsControllerPresignV1(presignRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UploadsApiFactory = UploadsApiFactory;
/**
 * UploadsApi - object-oriented interface
 * @export
 * @class UploadsApi
 * @extends {BaseAPI}
 */
var UploadsApi = /** @class */ (function (_super) {
    __extends(UploadsApi, _super);
    function UploadsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Complete S3 multipart upload for submission media
     * @param {CompleteSubmissionMultipartUploadDto} completeSubmissionMultipartUploadDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadsApi
     */
    UploadsApi.prototype.uploadsControllerCompleteSubmissionMultipartUploadV1 = function (completeSubmissionMultipartUploadDto, options) {
        var _this = this;
        return (0, exports.UploadsApiFp)(this.configuration).uploadsControllerCompleteSubmissionMultipartUploadV1(completeSubmissionMultipartUploadDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Initiate S3 multipart upload for submission media
     * @param {InitiateSubmissionMultipartUploadDto} initiateSubmissionMultipartUploadDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadsApi
     */
    UploadsApi.prototype.uploadsControllerInitiateSubmissionMultipartUploadV1 = function (initiateSubmissionMultipartUploadDto, options) {
        var _this = this;
        return (0, exports.UploadsApiFp)(this.configuration).uploadsControllerInitiateSubmissionMultipartUploadV1(initiateSubmissionMultipartUploadDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get S3 presigned URLs for multipart submission upload parts
     * @param {PresignSubmissionPartsDto} presignSubmissionPartsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadsApi
     */
    UploadsApi.prototype.uploadsControllerPresignSubmissionMultipartPartsV1 = function (presignSubmissionPartsDto, options) {
        var _this = this;
        return (0, exports.UploadsApiFp)(this.configuration).uploadsControllerPresignSubmissionMultipartPartsV1(presignSubmissionPartsDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get S3 presigned URL for client-side upload
     * @param {PresignRequestDto} presignRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadsApi
     */
    UploadsApi.prototype.uploadsControllerPresignV1 = function (presignRequestDto, options) {
        var _this = this;
        return (0, exports.UploadsApiFp)(this.configuration).uploadsControllerPresignV1(presignRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UploadsApi;
}(base_1.BaseAPI));
exports.UploadsApi = UploadsApi;
